module.exports = __webpack_public_path__ + "static/img/add-hover.76218df.png";